import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { disableChangePasswordFunctionality } from 'util/utils';
import ErrorMessage from 'components/ErrorMessage';
import { changePasswordSchema, changePasswordUiSchema } from './Schema';
import './UserEditor.scss';

export default class UserEditor extends PureComponent {
  onSubmit = ({ formData }) => {
    this.props.onChangePassword(formData);
  };

  render() {
    const { fetching, user } = this.props;
    const disableFunctionality = disableChangePasswordFunctionality();

    return (
      <div className="user-list-container">
        {disableFunctionality && (
          <ErrorMessage error="This functionality is currently disabled in Chairman. Please leverage self-service reset password flow from Command Center." />
        )}
        <Form
          disabled={disableFunctionality}
          schema={changePasswordSchema}
          uiSchema={changePasswordUiSchema}
          formData={user}
          onSubmit={this.onSubmit}
          enctype="multipart/form-data"
        >
          <Button
            bsClass="btn btn-primary btn-large"
            disabled={fetching || disableFunctionality}
            type="submit"
          >
            Save
          </Button>
        </Form>
      </div>
    );
  }
}

UserEditor.propTypes = {
  fetching: PropTypes.bool,
  user: PropTypes.object,
  onChangePassword: PropTypes.func,
};
